export const CreationTypes = ["M", "AV", "H", "PPI", "V"];
export type CreationType = (typeof CreationTypes)[number];
